import posthog from "posthog-js"

let initialized = false

export function enableAnalytics() {
  if (!process.env.GATSBY_POSTHOG_KEY) return

  if (!initialized) {
    posthog.init(process.env.GATSBY_POSTHOG_KEY, {
      api_host: process.env.GATSBY_POSTHOG_HOST || "https://eu.i.posthog.com",
      defaults: "2026-05-30",
      capture_pageview: "history_change",
      // Avoid PostHog probing public suffixes such as `.net` for this single-host site.
      cross_subdomain_cookie: false,
      opt_out_capturing_by_default: true,
      opt_out_persistence_by_default: true,
      person_profiles: "never",
      autocapture: false,
      disable_session_recording: true,
      respect_dnt: true,
    })
    initialized = true
  }

  if (posthog.get_explicit_consent_status() !== "granted") {
    posthog.opt_in_capturing({
      captureProperties: { consent_revision: 1 },
    })
    posthog.capture("$pageview", { consent_revision: 1 })
  }
}

export function disableAnalytics() {
  if (initialized) posthog.opt_out_capturing()
}

export function captureAnalyticsEvent(event, properties) {
  if (initialized && posthog.get_explicit_consent_status() === "granted") {
    posthog.capture(event, properties)
  }
}
